// src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { FileProvider } from './ContextAPI/FileContext';
import { DownloadsProvider } from './contexts/DownloadsContext';
import { UploadsProvider } from './contexts/UploadsContext';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Suppress ResizeObserver loop error - harmless browser quirk when layout changes rapidly (e.g. closing modals)
// See: https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
window.addEventListener('error', (e) => {
  if (e.message?.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
    return true;
  }
}, true);

ReactDOM.render(
  <FileProvider>
    <DownloadsProvider>
      <UploadsProvider>
        <App />
      </UploadsProvider>
    </DownloadsProvider>
  </FileProvider>,
  document.getElementById('root')
);

// Register the minimal service worker so the app is installable ("Add to
// Home Screen" / desktop Install). It caches nothing — see public/service-worker.js.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/service-worker.js`)
      .catch((err) => console.warn('Service worker registration failed:', err));
  });
}
